import { Heading } from "@stacklet/ui";

import { HelpDrawerTrigger } from "app/components/HelpDrawer/HelpDrawerTrigger";

interface Props {
  /** The notification rule name to display in the header */
  name: string;
}

export function EditNotificationRuleHeader({ name }: Props) {
  return (
    <div className="mb-6 flex items-center justify-between gap-2">
      <Heading level={2}>{`Edit Notification Rule: "${name}"`}</Heading>
      <HelpDrawerTrigger />
    </div>
  );
}
